require("jquery"); 
require("select2-3.5.1/select2.css");
require("select2-3.5.1/select2.js");
require("select2-3.5.1/select2_locale_ru.js");  


/** WEBPACK FOOTER **
 ** ./app_components/select2/index.js
 **/